/**
 *
 * EloquaVerify
 *
 */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import { makeSelectIsVerify, makeSelectError } from './selectors';
import { verifyEloqua } from './actions';
import reducer from './reducer';
import saga from './saga';
import queryString from 'query-string';
import {
  VerifyContainer,
  VerifyContent,
  VerifyHeaderWrapper,
  VerifyDivider,
  VerifyLogo,
} from './styled';
import logo from 'assets/img/brand/logo-full.png';
import triggerNotification from 'utils/triggerNotification';
import { NOTIFICATION } from 'common/constants';

export const EloquaVerify = props => {
  useInjectReducer({ key: 'eloquaVerify', reducer });
  useInjectSaga({ key: 'eloquaVerify', saga });

  const { verifyEloquaStart, isVerify, error } = props;

  const verifyCode = decodeURIComponent(queryString.parse(props.location.search).code);

  let state, integrationKey;

  try {
    state = JSON.parse(decodeURIComponent(queryString.parse(props.location.search).state));
    integrationKey = state && state.integrationKey;
  } catch (e) {
    triggerNotification({
      title: 'Something went wrong. Please try again',
      type: NOTIFICATION.TYPE.ERROR,
    });
  }

  useEffect(() => {
    if (verifyCode) {
      verifyEloquaStart({
        payload: { code: verifyCode, state: JSON.stringify(state), integrationKey },
        metadata: { projectName: state },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verifyCode]);
  return (
    <>
      <Helmet>
        <title>ZoomInfo Chat | Verify Eloqua</title>
        <meta name="description" content="Verify your Eloqua" />
      </Helmet>
      <VerifyContainer>
        <div className="d-flex justify-content-center p-5">
          <VerifyLogo src={logo} alt="zoominfo chat logo" />
        </div>
        <VerifyContent>
          {isVerify ? (
            <>
              <VerifyHeaderWrapper>Pending</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Verification Pending</p>
            </>
          ) : error ? (
            <>
              <VerifyHeaderWrapper>Failed</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Something went wrong while connecting Eloqua with ZoomInfo Chat</p>
            </>
          ) : (
            <>
              <VerifyHeaderWrapper>Successful</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Successfully connected your Eloqua with ZoomInfo Chat</p>
            </>
          )}
        </VerifyContent>
      </VerifyContainer>
    </>
  );
};
EloquaVerify.propTypes = {
  verifyEloquaStart: PropTypes.func.isRequired,
  isVerify: PropTypes.bool,
};
export const mapStateToProps = (state, props) => {
  // @dev you can pass props to makeSelectFuncs(props) like so.
  return createStructuredSelector({
    isVerify: makeSelectIsVerify(),
    error: makeSelectError(),
  });
};
export const mapDispatchToProps = dispatch => {
  return {
    verifyEloquaStart: ({ payload, metadata }) =>
      dispatch(verifyEloqua.start({ payload, metadata })),
  };
};
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withRouter, withConnect)(EloquaVerify);
